export const table = [
    {
        type: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_1',
        currency: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_2',
        service: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_3',
        enrollment: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_4',
        withdrawal: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_5'
    },
    {
        type: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_1',
        currency: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_2',
        service: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_3',
        enrollment: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_4',
        withdrawal: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_5'
    },
    {
        type: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_3_TEXT_1',
        currency: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_3_TEXT_2',
        service: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_3_TEXT_3',
        enrollment: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_3_TEXT_4',
        withdrawal: 'PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_3_TEXT_5'
    }
];
